import { apiClient, type PartnerToSubPartnerEntity } from '@/libs/api'
import { type PartnerToSubPartnerRequestQuery } from '@/libs/api/types'

export type FetchPartnerToSubPartnersQuery = {
  tenantKey: string
  query: PartnerToSubPartnerRequestQuery
}

export type FetchPartnerToSubPartnersResponse = {
  data: PartnerToSubPartnerEntity[]
}

export const fetchPartnerToSubPartners = async (
  { tenantKey, query }: FetchPartnerToSubPartnersQuery,
  signal?: AbortSignal
): Promise<FetchPartnerToSubPartnersResponse> => {
  const data = await apiClient._tenant(tenantKey).partner_to_sub_partner.$get({
    config: {
      signal
    },
    query: {
      ...query,
      enable: true,
      page: -1
    }
  })
  return data
}
